import { createSlice, PayloadAction, Reducer } from '@reduxjs/toolkit';

import { UPLOADS_SLICE_NAME } from './uploadsSliceName';
import { UploadsState, UPLOADS_INITIAL_STATE } from './uploadsState';
import { UploadStatus } from './uploadStatus';
import { uploadFile } from './thunks';

const uploadsSlice = createSlice({
  name: UPLOADS_SLICE_NAME,
  initialState: UPLOADS_INITIAL_STATE,
  reducers: {
    setProgress: (state, action: PayloadAction<{ id: string; requestId: string; progress: number }>) => {
      const item = state.items[action.payload.id];

      if (item?.requestId === action.payload.requestId) {
        item.progress = action.payload.progress;
      }
    },

    removeUpload: (state, action: PayloadAction<string>) => {
      delete state.items[action.payload];
    },
    clearUploads: () => ({ items: {} }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadFile.pending, (state, action) => {
        const { id, tag, file } = action.meta.arg;

        state.items[id] = {
          id,
          requestId: action.meta.requestId,
          tag,
          fileName: file.name,
          fileSize: file.size,
          progress: 0,
          status: UploadStatus.UPLOADING,
        };
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        const item = state.items[action.meta.arg.id];

        if (item?.requestId === action.meta.requestId) {
          item.progress = 100;
          item.status = UploadStatus.SUCCEEDED;
        }
      })
      .addCase(uploadFile.rejected, (state, action) => {
        const item = state.items[action.meta.arg.id];

        if (item?.requestId === action.meta.requestId) {
          item.status = UploadStatus.FAILED;
          item.error = action.payload;
        }
      });
  },
});

export const { removeUpload, clearUploads } = uploadsSlice.actions;
export const uploadsReducer: Reducer<UploadsState> = uploadsSlice.reducer;
